import { render, staticRenderFns } from "./decimalComSufixoNullable.vue?vue&type=template&id=425da945"
import script from "./decimalComSufixoNullable.ts?vue&type=script&lang=js&external"
export * from "./decimalComSufixoNullable.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('425da945')) {
      api.createRecord('425da945', component.options)
    } else {
      api.reload('425da945', component.options)
    }
    module.hot.accept("./decimalComSufixoNullable.vue?vue&type=template&id=425da945", function () {
      api.rerender('425da945', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/decimalComSufixoNullable.vue"
export default component.exports